<div class="lot-kpi">
  <div class="container">
    <div class="col-md-4 background-blue text-white height-box font-row">
      <h4 class="h-padding-box">
        <b>Submitted</b>
      </h4>
      <p><b>Quantity: </b> {{ (kpiData | async)?.submittedQuantity }}</p>
      <p><b>Value: </b> {{ (kpiData | async)?.submittedValue | myCurrency }}</p>
    </div>

    <div class="col-md-4 background-light-blue text-white height-box font-row">
      <h4 class="h-padding-box">
        <b>Requested</b>
      </h4>
      <p><b>Quantity: </b> {{ (kpiData | async)?.requestedQuantity }}</p>
      <p><b>Value: </b> {{ (kpiData | async)?.requestedValue | myCurrency }}</p>
    </div>

    <div class="col-md-4 background-blue text-white height-box font-row">
      <h4 class="h-padding-box">
        <b>Available</b>
      </h4>
      <p><b>Quantity: </b> {{ (kpiData | async)?.availableQuantity }}</p>
      <p><b>Value: </b> {{ (kpiData | async)?.availableValue | myCurrency }}</p>
    </div>
  </div>
</div>
